import { useImage, useVideo } from '@doist/marketist'

export function useCloudinaryImageLocal(imagePath: string) {
    const { getImage } = useImage()
    const image = getImage(imagePath)
    const isDevEnv = process.env.NEXT_PUBLIC_APP_ENV === 'development'
    return isDevEnv ? imagePath : image.toString()
}

export function useCloudinaryVideoLocal(videoPath: string): {
    videoUrl: string
    posterUrl?: string
} {
    const { getVideo, getPoster } = useVideo()
    const video = getVideo(videoPath)
    const poster = getPoster(videoPath)

    const isDevEnv = process.env.NEXT_PUBLIC_APP_ENV === 'development'
    return isDevEnv
        ? { videoUrl: videoPath }
        : { videoUrl: video.toString(), posterUrl: poster.toString() }
}
